import PropTypes from "prop-types";

const BookADemo = (props) => {

    return (
        <div className="form-iframe-contact">
            <iframe
                id="surface-iframe"
                src={process.env.NEXT_PUBLIC_SURFACE_BOOK_DEMO_FORM_URL || ''}
                frameBorder="0"
                allowFullScreen
                loading="eager"
                title="Book a demo">
            </iframe>
        </div>

    );
};
BookADemo.propTypes = {
    title: PropTypes.string,
    location: PropTypes.string,
};
export default BookADemo;